export const ModelCodeMinProductionYear: number = 2000;
export const ModelCodeMaxProductionYear: number = (new Date()).getFullYear();
